import { get_api_path } from './api';
import axios from 'axios';

// /**
//  * Make API call to compliance function in backend.
//  *
//  * @param {any} data - data to pass to backend
//  * @param {string} token - authorisation token obtained after login
//  *
//  * @return {object} - result in response object
//  */
// export async function compliance_check(data, token) {
//   const url = get_api_path('traxxid', 'compliance');
//   const response = await axios.post(url, data, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//       'Access-Control-Allow-Origin': true
//     }
//   });
//   return response.data.result;
// }
// /**
//  * Make API call to backend and get the list of countries used for DowJones Screening.
//  *
//  * @param {string} token - authorisation token obtained after login
//  *
//  * @return {array} - array of countries and their DowJones country code
//  */
// export async function get_countries(token) {
//   const url = get_api_path('traxxid', 'countries/list');
//   const response = await axios.get(url, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//       'Access-Control-Allow-Origin': true
//     }
//   });
//   return response.data.result;
// }
/**
 * Make API call to backend to verify login credentials and obtain access token to backend.
 *
 * @param {string} username - username (email) of the user
 * @param {string} password - password the user has input
 *
 * @return {object} - result of response object
 */
export async function login({ username, password }) {
  const url = get_api_path('traxxid', 'auth/login');
  const response = await axios.post(url, { username, password });
  return response.data.result;
}
